import classNames from 'classnames'
import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {NewInfoIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import Tooltip from '../../core/tooltip'
import './index.scss'

const percentages = {
    FULL_PERCENT: 80,
    HALF_PERCENT: 50
}
const INFO_SIZE = 20

const LinearProgressBar = ({value, max, config = {}}) => {
    const percentage = useMemo(() => (value / max) * 100, [value, max])
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const computedColors = useMemo(() => {
        const {filled, background, textColor, iconColor} = config?.defaultColors || {}

        return percentage >= percentages.FULL_PERCENT
            ? {
                filled: filled || colors.colorRed,
                background: background || colors.colorMediumRed,
                text_color: textColor || colors.colorRed,
                icon_color: iconColor || colors.colorRed
            }
            : percentage >= percentages.HALF_PERCENT
                ? {
                    filled: filled || colors.colorOrange,
                    background: background || colors.colorMutedOrange,
                    text_color: textColor || colors.colorOrange,
                    icon_color: iconColor || colors.colorOrange
                }
                : {
                    filled: filled || colors.colorVividBlue,
                    background: background || colors.colorMutedBlue,
                    text_color: textColor || colors.colorRichBlue,
                    icon_color: iconColor || colors.colorFilterTitle
                }
    }, [percentage, config?.defaultColors, isDarkMode])

    return (
        <div
            className={classNames('usage-limit-bar', {
                dark: isDarkMode
            })}

            style={{
                '--filled-color': computedColors.filled,
                '--background-color': computedColors.background,
                '--text-color': computedColors.text_color,
                '--percentage': `${percentage}%`
            }}
        >
            <div className="progress-text">
                <span className="progress-text-value">{`${value}/`}</span>
                {max}
            </div>
            <div
                className="progress-bar"
            >
                <div className="progress" style={{width: `${percentage}%`}}></div>
            </div>
            {config?.tooltip_text && (
                <div className="progress-label">
                    <Tooltip trigger="mouseenter" content={config.tooltip_text} placement="top">
                        {config?.label_text && <span className="label-text">{config.label_text}</span>}
                        <NewInfoIcon
                            fillColor={computedColors.icon_color}
                            width={INFO_SIZE}
                            height={INFO_SIZE}
                        />
                    </Tooltip>
                </div>
            )}
        </div>
    )
}

export default LinearProgressBar
